<app-breadcrumb></app-breadcrumb>
<app-notification-message
  [errorMessage]="errorMessage"
  [successMessage]="successMessage"
>
</app-notification-message>

<div class="content ms-4 me-4">
  <div class="d-flex justify-content-between roboto-medium">
    <h2 class="roboto-medium title" *ngIf="selectedTab=='AET Safety Dashboard' else showHeader">AET Safety Dashboard</h2>
    <ng-template #showHeader>
      <h2 class="roboto-medium title">AET Safety KPI</h2>
    </ng-template>
    <div class="roboto-medium">
      <img src="./assets/images/export_black.svg" title="Export" (click)="onBtExport()" class="export-icon">
      <label class="reset me-3 mb-1" (click)="refreshData()" *ngIf="selectedTab == 'AET Safety Dashboard'">
        <img src="assets/images/refresh.svg" title="Refresh" />
      </label>
      <select *ngIf="selectedTab == 'AET Safety Dashboard'"
        [(ngModel)]="selected_position_id"
        [ngModelOptions]="{ standalone: true }"
        class="mb-1 b2 drpdwn_period"
      >
        <option *ngFor="let siteItem of siteItems" [value]="siteItem.position">
          {{ siteItem.description }}
        </option>
      </select>
      <button *ngIf="selectedTab == 'AET Safety Dashboard'"
        [ngClass]="{ 'b2 mb-1': !autoPress, 'b3 mb-1': autoPress }"
        (click)="auto()"
      >
        AUTO
      </button>
      <button
        *ngIf="isAccessible"
        class="mb-1 me-0 black-button"
        (click)="createEvent()"
      >
        CREATE EVENT
      </button>
    </div>
  </div>

  <div class="mt-4">
    <mat-nav-list class="inline">
      <a mat-list-item (click)="safetyDashboard()" [ngClass]="highlightSafety? 'active' : 'inactive' "
        class="menu bar">Dashboard</a>
      <div class="vr"></div>
      <a mat-list-item (click)="safetyKPI()" [ngClass]="highlightKPI? 'active' : 'inactive' " class="menu bar">KPI</a>
      <div class="vr"></div>
    </mat-nav-list>
  </div>
  <hr>

  <div *ngIf="selectedTab == 'AET Safety Dashboard'">
    <h4 class="roboto-medium title">Safety Events</h4>

    <div class="grid-agg px-0">
      <ag-grid-angular [ngStyle]="{
        height: dynamicHeight + 'px',
        width: '100%',
        'font-family': 'Roboto'
      }"
      class="ag-theme-balham grid-items safety-grid"
      (gridReady)="onGridReady($event)"
      [columnDefs]="columnDefs"
      [rowData]="displayRowData"
      [icons]="icons"
      [defaultColDef]="defaultColDef"
      [suppressCellSelection]="true"
      [headerHeight]="40"
      [rowHeight]="rowHeight"
      [detailRowHeight]="detailRowHeight"
      [context]="context"
      [pagination]="true"
      [detailCellRendererParams]="detailCellRendererParams"
      [getRowStyle]="getRowStyle"
      [masterDetail]="true"
      (firstDataRendered)="onFirstDataRendered($event)"
      [gridOptions]="gridOptions"
      [rowClassRules]="rowClassRules"
      [tooltipShowDelay]="tooltipShowDelay"
      [tooltipHideDelay]="tooltipHideDelay"
      [tooltipMouseTrack]="tooltipMouseTrack"
      (paginationChanged)="onPaginationChanged()"
      [pagination]="true"
      [paginationPageSize]="paginationPageSize"
      [suppressPaginationPanel]="true"
      (filterChanged)="onFilterChanged($event)"
      [excelStyles]="excelStyles"
      (modelUpdated)="onModelUpdated()"
      [theme]="'legacy'"
    ></ag-grid-angular>
    <!-- [groupDisplayType]="groupDisplayType" -->
    <div
      class="d-flex pagination px-2 align-items-center justify-content-between"
    >
      <div>
        <div>
          <label class="page-drpdwn-label me-2">Records/Page: </label>
          <select (change)="onPageSizeChanged($event)" class="paginate_drpdwn">
            <option value="5">5</option>
            <option value="10" selected>10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="{{ rowCount }}">ALL</option>
          </select>
        </div>
      </div>
      <div class="d-flex align-items-center gap-3">
        <div>Viewing Records</div>

        <img
          src="assets/images/Icon awesome-fast-forward.svg"
          width="10"
          (click)="goToFirstPage()"
          class="text-primary reverse firstPage"
          [ngClass]="{
            disable_icon: getCurrentPage() == true,
            enable_icon: getCurrentPage() != true
          }"
        />

        <img
          src="assets/images/Icon metro-next.svg"
          (click)="goToPreviousPage()"
          class="text-primary reverse previousPage"
          [ngClass]="{
            disable_icon: getCurrentPage() == true,
            enable_icon: getCurrentPage() != true
          }"
        />

        <div>
          (
          <span class="value" id="lbCurrentPage"></span> -
          <span class="value" id="lbTotalPages"></span>)&nbsp; OF &nbsp;
          <span>{{ rowCount }}</span>
        </div>

        <img
          src="assets/images/Icon metro-next.svg"
          (click)="goToNexpage()"
          class="text-primary nextPage"
          [ngClass]="{
            disable_icon: isLastPage() == true || rowCount == 0,
            enable_icon: isLastPage() != true || rowCount > 0
          }"
        />
        <img
          src="assets/images/Icon awesome-fast-forward.svg"
          width="10"
          (click)="goToLastPage()"
          class="text-primary lastPage"
          [ngClass]="{
            disable_icon: isLastPage() == true || rowCount == 0,
            enable_icon: isLastPage() != true || rowCount > 0
          }" />
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="selectedTab == 'Safety Dashboard KPI'">
    <mat-accordion>

      <!-- <mat-expansion-panel #panel class="mat-elevation-z0" (opened)="openLine()"> -->
      <!-- <mat-expansion-panel-header  class="header-container mb-4">
      <mat-panel-title> </mat-panel-title>
      <mat-panel-description class="bardesc">
        Abnormals by Time Span
      </mat-panel-description>
    </mat-expansion-panel-header> -->
      <div class="row d-flex
                mt-2
                icon-container
                ms-4
                kpibuttons">
        <!-- <img src="./assets/images/export_black.svg" title="Export" (click)="onBtExport2()"
          style="width:47px; margin-bottom: 16px;cursor:pointer;" /> -->
      </div>

      <div class="row">
        <div class="col-2">
          <div class="row spacing rspace">
            <div class="col-6 labelSpace"><label for="start">Time Span</label></div>

            <div class="col-6">
                <mat-select
                  [(ngModel)]="selectedSpan"
                  [panelWidth]="null"
                  (selectionChange)="onTimeSpanChange()"
                  [disableOptionCentering]="true"
                  class="mat-sel diff"
                  style="width: 137px;"
                >
                  <mat-option *ngFor="let option of timespanlist" [value]="option">
                    {{ option }}
                  </mat-option>
                </mat-select>
            </div>
            
          </div>
          <div class="row spacing rspace">
            <div class="col-6 labelSpace"><label for="start">Start Date</label></div>
            <div class="col-6">
              <input class="dateStyle" type="date" [(ngModel)]="startDateLine" onkeydown="return false" (change) = "onTimeSpanChange()" />
            </div>
          </div>

          <div class="row spacing rspace">
            <div class="col-6 labelSpace"><label for="end">End Date</label></div>
            <div class="col-6">
              <input class="dateStyle" type="date" [(ngModel)]="endDateLine" onkeydown="return false" (change) = "onTimeSpanChange()"/>
            </div>
          </div>
          <div class="row spacing rspace">
            <div class="col-6 labelSpace"><label for="end">Region</label></div>
            <div class="col-6">
                <!-- <mat-select
                  multiple
                  class="mat-sel"
                  style="width: 137px;"
                  [(ngModel)]="selectedRegionLine"
                  (selectionChange)="onTimeSpanChange()"
                  [disableOptionCentering]="true"
                  placeholder="Select"
                >
                  <mat-option *ngFor="let item of dropdownRegionLine" [value]="item">
                    {{ item.value }}
                  </mat-option>
                </mat-select> -->
                <mat-form-field appearance="outline" class="fixed-select" style="height:26px !important">
                  <mat-select [(ngModel)]="selectedRegionLine" [multiple]="true" [panelWidth]="null" (selectionChange)="onTimeSpanChange()">
                      <div style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 1;">
                        <mat-checkbox
                          style="margin-left: 8px;"
                          [checked]="isAllSelected(selectedRegionLine,dropdownRegionLine)"
                          [indeterminate]="isIndeterminate(selectedRegionLine,dropdownRegionLine)"
                          (change)="toggleSelectAll($event,'selectedRegionLine',dropdownRegionLine)">
                        </mat-checkbox>
                        <ngx-mat-select-search 
                          [formControl]="regionFilterCtrl"
                          placeholderLabel="Search"
                          noEntriesFoundLabel="No options found">
                        </ngx-mat-select-search>
                      </div>
                      <div style="max-height: 195px; overflow-y: auto;">
                    <mat-option *ngFor="let d of filteredRegion | async" [value]="d" style="font-size: 13px;">
                      {{ d.value }}
                    </mat-option>
                    </div>
                  </mat-select>
                </mat-form-field>
              
            </div>
          </div>
          <div class="row spacing rspace">
            <div class="col-6 labelSpace"><label for="end">LP</label></div>
            <div class="col-6">
                <!-- <mat-select
                  multiple
                  class="mat-sel"
                  style="width: 137px;"
                  [(ngModel)]="selectedLpLine"
                  (selectionChange)="onTimeSpanChange()"
                  placeholder=""
                  [disableOptionCentering]="true"
                >
                  <mat-option *ngFor="let item of dropdownLpLine" [value]="item">
                    {{ item.label }}
                  </mat-option>
                </mat-select> -->
                <mat-form-field appearance="outline" class="fixed-select" style="height:26px !important">
                  <mat-select [(ngModel)]="selectedLpLine" [multiple]="true" [panelWidth]="null" (selectionChange)="onTimeSpanChange()">
                      <div style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 1;">
                        <mat-checkbox
                          style="margin-right: 8px;"
                          [checked]="isAllSelected(selectedLpLine,dropdownLpLine)"
                          [indeterminate]="isIndeterminate(selectedLpLine,dropdownLpLine)"
                          (change)="toggleSelectAll($event,'selectedLpLine',dropdownLpLine)">
                        </mat-checkbox>
                        <ngx-mat-select-search
                          [formControl]="lpFilterCtrl"
                          placeholderLabel="Search"
                          noEntriesFoundLabel="No options found">
                        </ngx-mat-select-search>
                      </div>
                      <div style="max-height: 195px; overflow-y: auto;">
                    <mat-option *ngFor="let d of filteredLp | async" [value]="d" style="font-size: 13px;">
                      {{ d.label }}
                    </mat-option>
                    </div>
                  </mat-select>
                </mat-form-field>
            </div>
          </div>

          <div class="row spacing rspace">
            <div class="col-6 labelSpace"><label for="end">Severity</label></div>
            <div class="col-6">
                <!-- <mat-select
                  multiple
                  class="mat-sel"
                  style="width: 137px;"
                  [(ngModel)]="selectedSeverityLine"
                  (selectionChange)="onTimeSpanChange()"
                  placeholder=""
                  [disableOptionCentering]="true"
                >
                  <mat-option *ngFor="let item of dropdownSeverityLine" [value]="item">
                    {{ item.value }}
                  </mat-option>
                </mat-select> -->
                <mat-form-field appearance="outline" class="fixed-select" style="height:26px !important">
                  <mat-select [(ngModel)]="selectedSeverityLine" [multiple]="true" [panelWidth]="null" (selectionChange)="onTimeSpanChange()">
                      <div style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 1;">
                        <mat-checkbox
                          style="margin-left: 8px;"
                          [checked]="isAllSelected(selectedSeverityLine,dropdownSeverityLine)"
                          [indeterminate]="isIndeterminate(selectedSeverityLine,dropdownSeverityLine)"
                          (change)="toggleSelectAll($event,'selectedSeverityLine',dropdownSeverityLine)">
                        </mat-checkbox>
                        <ngx-mat-select-search
                          [formControl]="severityFilterCtrl"
                          placeholderLabel="Search"
                          noEntriesFoundLabel="No options found">
                        </ngx-mat-select-search>
                      </div>
                      <div style="max-height: 200px; overflow-y: auto;">
                        <mat-option *ngFor="let d of filteredSeverity | async" [value]="d" style="font-size: 13px;">
                      {{ d.value }}
                    </mat-option>
                    </div>
                  </mat-select>
                </mat-form-field>
              
            </div>
          </div>

        </div>
      </div>

      <div class="row spacing">
        <div class="col-6">
          <button style="width: 85px;
        height: 35px; margin-top:15px; font-size: 13px;
        "class="black-button" (click)="resetLine()">Reset</button>
        </div>
        <div class="col-6">
        </div>
      </div>

      <div class="lineGraph">
        <h2 class="text-center pt-5 pb-3">Safety Incidents</h2>
        <div>
          <canvas baseChart
          [datasets]="lineChartData"
          [labels]="lineChartLabelsBinding"
          [options]="lineChartOptions"
          [type]="lineChartType">
        </canvas>
        
        </div>
      </div>
      
    </mat-accordion>
  </div>

</div>